export default __webpack_public_path__ + "static/media/icue_220t.1314ab8b.jpg";